(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/product-mapping/assets/javascripts/product-mapping.js') >= 0) return;  svs.modules.push('/components/numbergames/product-mapping/assets/javascripts/product-mapping.js');

'use strict';

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var urlMapping;
var CONSTANTS = {
  EUROJACKPOT: 'EUROJACKPOT',
  EUROJACKPOT_FRIDAY: 'ELOTTO',
  EUROJACKPOT_TUESDAY: 'TELOTTO',
  KENO: 'KENO',
  LOTTO: 'LOTTO',
  LOTTO_WEDNESDAY: 'ONSLOTTO',
  LOTTO_SATURDAY: 'LORLOTTO',
  VIKINGLOTTO: 'VIKINGLOTTO',
  JOKER: 'JOKER',
  JOKER_WEDNESDAY: 'ONSJOKER',
  JOKER_SATURDAY: 'LORJOKER'
};
var joker = {
  name: 'Joker',
  id: 'JOKER',
  allNumericIds: [13, 12],
  drawId: 'joker',
  branding: 'joker',
  isProductFamily: true
};
var onsjoker = {
  name: 'Joker',
  numeric: 13,
  id: 'JOKER',
  itsId: 'ONSJOKER',
  drawId: 'jokerwednesday',
  branding: 'joker',
  day: 'Onsdag',
  dayName: 'Joker Onsdag',
  isDaySpecific: true
};
var lorjoker = {
  name: 'Joker',
  numeric: 12,
  id: 'JOKER',
  itsId: 'LORJOKER',
  drawId: 'jokersaturday',
  branding: 'joker',
  day: 'Lördag',
  dayName: 'Joker Lördag',
  isDaySpecific: true
};
var eurojackpot = {
  name: 'Eurojackpot',
  allNumericIds: [37, 29],
  campaignId: 47,
  campaignItsId: 'ELOTTOACH',
  id: 'EUROJACKPOT',
  wagersId: 'eurojackpot',
  drawId: 'eurojackpot',
  branding: 'eurojackpot',
  isProductFamily: true
};
var eurojackpotFriday = {
  name: 'Eurojackpot',
  numeric: 29,
  campaignId: 47,
  campaignItsId: 'ELOTTOACH',
  id: 'EUROJACKPOT',
  itsId: 'ELOTTO',
  wagersId: 'eurojackpot',
  drawId: 'eurojackpotfriday',
  dayName: 'Eurojackpot Fredag',
  branding: 'eurojackpot',
  day: 'Fredag',
  isDaySpecific: true
};
var eurojackpotTuesday = {
  name: 'Eurojackpot',
  numeric: 37,
  campaignId: 47,
  campaignItsId: 'ELOTTOACH',
  id: 'EUROJACKPOT',
  itsId: 'TELOTTO',
  wagersId: 'eurojackpot',
  drawId: 'eurojackpottuesday',
  branding: 'eurojackpot',
  day: 'Tisdag',
  dayName: 'Eurojackpot Tisdag',
  isDaySpecific: true
};
var keno = {
  name: 'Keno',
  numeric: 9,
  campaignId: 46,
  campaignItsId: 'KENOACH',
  id: 'KENO',
  itsId: 'KENO',
  wagersId: 'keno',
  drawId: 'keno',
  branding: 'keno',
  isDaily: true
};
var lotto = {
  name: 'Lotto',
  id: 'LOTTO',
  allNumericIds: [11, 10],
  campaignId: 35,
  campaignItsId: 'ACHANS',
  wagersId: 'lotto',
  drawId: 'lotto',
  branding: 'lotto',
  joker: joker,
  isProductFamily: true
};
var onslotto = {
  name: 'Lotto',
  numeric: 11,
  campaignId: 35,
  campaignItsId: 'ACHANS',
  id: 'LOTTO',
  itsId: 'ONSLOTTO',
  wagersId: 'lotto',
  drawId: 'lottowednesday',
  branding: 'lotto',
  day: 'Onsdag',
  dayName: 'Lotto Onsdag',
  joker: onsjoker,
  isDaySpecific: true
};
var lorlotto = {
  name: 'Lotto',
  numeric: 10,
  campaignId: 35,
  campaignItsId: 'ACHANS',
  id: 'LOTTO',
  itsId: 'LORLOTTO',
  wagersId: 'lotto',
  drawId: 'lottosaturday',
  branding: 'lotto',
  day: 'Lördag',
  dayName: 'Lotto Lördag',
  joker: lorjoker,
  isDaySpecific: true
};
var vikinglotto = {
  name: 'Vikinglotto',
  numeric: 14,
  id: 'VIKINGLOTTO',
  itsId: 'VIKING',
  wagersId: 'viking',
  drawId: 'vikinglotto',
  branding: 'vikinglotto',
  day: 'Onsdag',
  joker: onsjoker
};
var products = {
  9: keno,
  keno: keno,
  10: lorlotto,
  lor: lorlotto,
  lorlotto: lorlotto,
  'lotto lördag': lorlotto,
  lottolordag: lorlotto,
  lottosaturday: lorlotto,
  11: onslotto,
  ons: onslotto,
  onslotto: onslotto,
  'lotto onsdag': onslotto,
  lottoonsdag: onslotto,
  lottowednesday: onslotto,
  lotto: lotto,
  'lotto onsdag & lördag': lotto,
  'lotto 1': lotto,
  'lotto 1 onsdag': onslotto,
  'lotto 1 lördag': lorlotto,
  'lotto 2': lotto,
  'lotto 2 onsdag': onslotto,
  'lotto 2 lördag': lorlotto,
  12: lorjoker,
  lorjoker: lorjoker,
  'joker lördag': lorjoker,
  jokerlordag: lorjoker,
  jokersaturday: lorjoker,
  13: onsjoker,
  onsjoker: onsjoker,
  'joker onsdag': onsjoker,
  jokeronsdag: onsjoker,
  jokerwednesday: onsjoker,
  joker: joker,
  'joker onsdag & lördag': joker,
  14: vikinglotto,
  viking: vikinglotto,
  vikinglotto: vikinglotto,
  29: eurojackpotFriday,
  elotto: eurojackpotFriday,
  eurojackpotfriday: eurojackpotFriday,
  eurojackpotfredag: eurojackpotFriday,
  'eurojackpot fredag': eurojackpotFriday,
  37: eurojackpotTuesday,
  telotto: eurojackpotTuesday,
  eurojackpottuesday: eurojackpotTuesday,
  eurojackpottisdag: eurojackpotTuesday,
  'eurojackpot tisdag': eurojackpotTuesday,
  eurojackpot: eurojackpot,
  'eurojackpot tisdag & fredag': eurojackpot
};
function getProduct(product) {
  if (typeof product === 'string') {
    product = product.toLowerCase();
  }
  return products[product];
}
function getProductNumeric(product) {
  product = getProduct(product);
  if (product) {
    return product.numeric;
  }
  return 0;
}
function getProductId(product) {
  product = getProduct(product);
  if (product) {
    return product.id;
  }
  return '';
}
function getProductItsId(product) {
  product = getProduct(product);
  if (product && product.itsId) {
    return product.itsId;
  }
  return '';
}
function getProductWagersId(product) {
  product = getProduct(product);
  if (product) {
    return product.wagersId;
  }
  return '';
}
function getProductName(product) {
  product = getProduct(product);
  if (product) {
    return product.name;
  }
  return '';
}
function getProductDayName(product) {
  product = getProduct(product);
  if (product) {
    return product.dayName || product.name;
  }
  return '';
}
function getProductCampaignId(product) {
  product = getProduct(product);
  if (product) {
    return product.campaignId;
  }
  return '';
}
function getCampaignItsId(product) {
  product = getProduct(product);
  if (product) {
    return product.campaignItsId;
  }
  return '';
}

function getDay(product) {
  product = getProduct(product);
  if (product && product.day) {
    return product.day;
  }
  return '';
}
function getProductDrawId(product) {
  product = getProduct(product);
  if (product) {
    return product.drawId;
  }
  return '';
}
function getBrandingClass(product) {
  product = getProduct(product);
  if (product) {
    return product.branding;
  }
  return '';
}
function getAllNumericIds(product) {
  var productObj = getProduct(product);
  if (productObj) {
    return productObj.allNumericIds || [productObj.numeric];
  }
  if (product !== undefined) {
    return [];
  }
  return [keno.numeric].concat(_toConsumableArray(lotto.allNumericIds), _toConsumableArray(joker.allNumericIds), [vikinglotto.numeric], _toConsumableArray(eurojackpot.allNumericIds));
}
function getAllItsIds(product) {
  return getAllNumericIds(product).map(function (id) {
    return getProductItsId(id);
  });
}
function getAllDrawIds(product) {
  return getAllNumericIds(product).map(function (id) {
    return getProductDrawId(id);
  });
}
function hasJoker(product) {
  product = getProduct(product);
  return Boolean(product && product.joker);
}

function getJokerDrawId(product) {
  product = getProduct(product);
  if (product && product.joker) {
    return product.joker.drawId;
  }
  return '';
}

function getJokerProductId(product) {
  product = getProduct(product);
  if (product && product.joker) {
    return product.joker.itsId || product.joker.id;
  }
  return '';
}

function getJokerProductNumeric(product) {
  var _product$joker$numeri, _product, _product$joker;
  product = getProduct(product);
  return (_product$joker$numeri = (_product = product) === null || _product === void 0 ? void 0 : (_product$joker = _product.joker) === null || _product$joker === void 0 ? void 0 : _product$joker.numeric) !== null && _product$joker$numeri !== void 0 ? _product$joker$numeri : 0;
}
function isDaySpecificId(product) {
  var _product$isDaySpecifi, _product2;
  product = getProduct(product);
  return (_product$isDaySpecifi = (_product2 = product) === null || _product2 === void 0 ? void 0 : _product2.isDaySpecific) !== null && _product$isDaySpecifi !== void 0 ? _product$isDaySpecifi : false;
}
function isProductFamily(product) {
  var _product$isProductFam, _product3;
  product = getProduct(product);
  return (_product$isProductFam = (_product3 = product) === null || _product3 === void 0 ? void 0 : _product3.isProductFamily) !== null && _product$isProductFam !== void 0 ? _product$isProductFam : false;
}
function isLotto(product) {
  return getProductId(product) === CONSTANTS.LOTTO;
}
function isLottoSaturday(product) {
  return getProductItsId(product) === CONSTANTS.LOTTO_SATURDAY;
}
function isLottoWednesday(product) {
  return getProductItsId(product) === CONSTANTS.LOTTO_WEDNESDAY;
}
function isJoker(product) {
  return getProductId(product) === CONSTANTS.JOKER;
}
function isKeno(product) {
  return getProductId(product) === CONSTANTS.KENO;
}
function isEurojackpot(product) {
  return getProductId(product) === CONSTANTS.EUROJACKPOT;
}
function isEurojackpotTuesday(product) {
  return getProductItsId(product) === CONSTANTS.EUROJACKPOT_TUESDAY;
}
function isEurojackpotFriday(product) {
  return getProductItsId(product) === CONSTANTS.EUROJACKPOT_FRIDAY;
}
function isVikinglotto(product) {
  return getProductId(product) === CONSTANTS.VIKINGLOTTO;
}
function isSameProduct(product1, product2) {
  var n1 = getProductNumeric(product1);
  var n2 = getProductNumeric(product2);
  if (n1 && n2) {
    return n1 === n2;
  }
  var p1 = getProductId(product1);
  var p2 = getProductId(product2);
  if (p1 && p2) {
    return p1 === p2;
  }
  return false;
}
function isDaily(product) {
  var _getProduct;
  return Boolean((_getProduct = getProduct(product)) === null || _getProduct === void 0 ? void 0 : _getProduct.isDaily);
}
function getProductUrlMapping(product, urlKey) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var url = urlMapping.get("".concat(getBrandingClass(product), "_").concat(urlKey));
  Object.entries(params).forEach(function (_ref) {
    var _url, _url$replace;
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    url = (_url = url) === null || _url === void 0 ? void 0 : (_url$replace = _url.replace) === null || _url$replace === void 0 ? void 0 : _url$replace.call(_url, ":".concat(key), value);
  });
  return url;
}

function getUrlMappingOngoingBet(product, params) {
  return getProductUrlMapping(product, 'ongoing_bet', params);
}
var productMapping = {
  products: products,
  CONSTANTS: CONSTANTS,
  getProductNumeric: getProductNumeric,
  getProductId: getProductId,
  getProductCampaignId: getProductCampaignId,
  getCampaignItsId: getCampaignItsId,
  getProductItsId: getProductItsId,
  getProductWagersId: getProductWagersId,
  getProductName: getProductName,
  getProductDayName: getProductDayName,
  getBrandingClass: getBrandingClass,
  getDay: getDay,
  getProductDrawId: getProductDrawId,
  getAllNumericIds: getAllNumericIds,
  getAllItsIds: getAllItsIds,
  getAllDrawIds: getAllDrawIds,
  hasJoker: hasJoker,
  getJokerDrawId: getJokerDrawId,
  getJokerProductId: getJokerProductId,
  getJokerProductNumeric: getJokerProductNumeric,
  isDaySpecificId: isDaySpecificId,
  isProductFamily: isProductFamily,
  isEurojackpot: isEurojackpot,
  isEurojackpotFriday: isEurojackpotFriday,
  isEurojackpotTuesday: isEurojackpotTuesday,
  isKeno: isKeno,
  isLotto: isLotto,
  isLottoSaturday: isLottoSaturday,
  isLottoWednesday: isLottoWednesday,
  isVikinglotto: isVikinglotto,
  isJoker: isJoker,
  isSameProduct: isSameProduct,
  isDaily: isDaily,
  getUrlMappingOngoingBet: getUrlMappingOngoingBet
};
if (svs.isServer) {
  var trinidadCore = require('trinidad-core').core;
  urlMapping = trinidadCore.urlMapping;
  module.exports = productMapping;
} else {
  urlMapping = svs.core.urlMapping;
  svs.numbergames = svs.numbergames || {};
  svs.numbergames.productMapping = productMapping;
}

 })(window);